import React, { useEffect, useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { propOr } from 'ramda';
import { determineLocale } from '../utils/determineLocale';
import { LEGACY_SUPPORTED_LANGUAGES_KEY, RTL_LANG } from '../constants/i18n';
import { renderTrackEvent } from '../lib/analyticsTracking';
import {
  ACTION_AUX_PARAMS,
  ACTIONS,
  CONTROL_NAMES,
  SCREEN_NAMES
} from '../jweb/constants';
import {
  CreateAnalyticsControlEvent,
  CreateAnalyticsScreenEvent,
  ProcessAuxParams
} from '../utils/simpleUIAnalytics';
import { sendSimpleUiEvent } from '../jweb/plugins/dataCollection';
import {
  ButtonEasyStartModify,
  PageContainer,
  ContentContainer,
  InnerContainer,
  TextContent,
  Title,
  BodyText,
  ButtonContainer
} from '../styles/EasyStartModifyConsent';

const EasyStartModifyConsent = ({
  handleClick,
  csData = {},
  loading,
  declineAllLoading,
  declineAllClick,
}) => {
  
  const title = propOr('Help improve HP printers and services', 'title', csData);
  const body = propOr('', 'body', csData);
  const footer = propOr('', 'footer', csData);
  const agreeButton = propOr('Accept', 'continueButton', csData);
  const declineButton = propOr('Decline', 'backButton', csData);

  
  const { language } = determineLocale(LEGACY_SUPPORTED_LANGUAGES_KEY);
  const isRTL = RTL_LANG.includes(language) ? true : false;
  
  const [isRenderContinueButton, setRenderContinueButton] = useState(false);
  const { ffAnalyticsTracking } = useFlags();

  const userActionAuxParams = {
    source: ACTION_AUX_PARAMS.SOURCE.HP_SMART_APP,
    flow: ACTION_AUX_PARAMS.FLOW.EASY_START_MODIFY_CONSENT
  };

  useEffect(() => {
    if (ffAnalyticsTracking) {
      renderTrackEvent(ffAnalyticsTracking);
      setRenderContinueButton(true);
    }
  }, [ffAnalyticsTracking]);

  useEffect(() => {
    if (isRenderContinueButton) {
      const auxParams = ProcessAuxParams(userActionAuxParams);
      const screenEvent = CreateAnalyticsScreenEvent(
        SCREEN_NAMES.EASY_START_MODIFY_CONSENT,
        auxParams
      );
      sendSimpleUiEvent(screenEvent);
    }
  }, [isRenderContinueButton]);

  const agreeClickBatchEvent = () => {
    const auxParams = ProcessAuxParams(userActionAuxParams);
    const controlEvent = CreateAnalyticsControlEvent(
      CONTROL_NAMES.EASY_START_MODIFY_CONSENT_AGREE_BUTTON,
      ACTIONS.CLICKED,
      auxParams
    );
    sendSimpleUiEvent(controlEvent);
  };

  const declineClickBatchEvent = () => {
    const auxParams = ProcessAuxParams(userActionAuxParams);
    const controlEvent = CreateAnalyticsControlEvent(
      CONTROL_NAMES.EASY_START_MODIFY_CONSENT_DECLINE_BUTTON,
      ACTIONS.CLICKED,
      auxParams
    );
    sendSimpleUiEvent(controlEvent);
  };

  const handleAgreeClick = () => {
    agreeClickBatchEvent();
    handleClick();
  };

  const handleDeclineClick = () => {
    declineClickBatchEvent();
    declineAllClick();
  };

  return (
    <PageContainer className="body-regular">
      <ContentContainer data-testid="easy-start-modify-consent">
        <InnerContainer>
          <TextContent>
            <Title className="title-small">{title}</Title>
            <BodyText className="body-regular" dangerouslySetInnerHTML={{ __html: `${body}${footer}` }} />
          </TextContent>
          <ButtonContainer>
            <ButtonEasyStartModify
              data-testid="decline-button"
              onClick={handleDeclineClick}
              appearance="secondary"
              loading={declineAllLoading}
              disabled={loading}
              id="consent-decline-button"
            >
              {declineButton}
            </ButtonEasyStartModify>
            <ButtonEasyStartModify
              data-testid="agree-button"
              onClick={handleAgreeClick}
              appearance="secondary"
              loading={loading}
              disabled={loading}
              id="consent-agree-button"
            >
              {agreeButton}
            </ButtonEasyStartModify>
          </ButtonContainer>
        </InnerContainer>
      </ContentContainer>
    </PageContainer>
  );
};

export default EasyStartModifyConsent;
